import {
  createContext,
  type ReactNode,
  useContext,
  useLayoutEffect,
  useMemo,
  useState,
} from 'react';

/** Obsah horní lišty určuje stránka; shell ho vykreslí. */
export interface TopbarState {
  title: string;
  /** cesta pro tlačítko Zpět, když není kam se vrátit v historii */
  back?: string;
  /** vpravo: přepínač firem */
  right?: 'companyChip';
}

interface TopbarCtx {
  state: TopbarState;
  set: (s: TopbarState) => void;
}

const Ctx = createContext<TopbarCtx | null>(null);

export function TopbarProvider({ children }: { children: ReactNode }) {
  const [state, set] = useState<TopbarState>({ title: '' });
  const value = useMemo(() => ({ state, set }), [state]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useTopbarState(): TopbarState {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useTopbarState mimo TopbarProvider');
  return ctx.state;
}

export function useTopbar(title: string, opts: Omit<TopbarState, 'title'> = {}): void {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useTopbar mimo TopbarProvider');
  const { back, right } = opts;
  useLayoutEffect(() => {
    ctx.set({ title, back, right });
  }, [ctx.set, title, back, right]);
}
